module.exports = __webpack_public_path__ + "img/company_cert_bg_1.a1740a63.png";